import React, { useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { recurrenceOptions } from '../../settings/recurrenceDropdownData'
import { LabelInputField } from '../LabelInputField/LabelInputField'
import { LabelSelect } from '../LabelSelect/LabelSelect'
import { LabelSelectOption } from '../LabelSelect/style'

import { RecurrenceRange } from './RecurrenceRange'
import {
  RecurrenceCheckboxWrapper,
  RecurrenceCheckbox,
  RecurrenceLabel,
  RecurrenceOptionsWrapper,
  RecurrenceOptionsLabel,
} from './style'

export type TRecurrenceOption = 'stopAfter' | 'stopOnDate' | 'never'

export interface IProps {
  setValue: UseFormSetValue<any>
  watchIsRepeat: boolean
  watchRepeatOption: any
}

export const AppointmentRecurrence = ({
  setValue,
  watchIsRepeat,
  watchRepeatOption,
}: IProps) => {
  const { t } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)

  const RecurrenceOptions: JSX.Element[] = recurrenceOptions.map(
    (recurrenceOption, index) => (
      <LabelSelectOption
        key={recurrenceOption}
        value={recurrenceOption}
        onClick={() => setValue('repeatOption', recurrenceOption)}
        selected={index === 0}>
        {t(`${recurrenceOption}`)}
      </LabelSelectOption>
    ),
  )

  return (
    <>
      <RecurrenceCheckboxWrapper
        onClick={() => {
          setIsChecked(!isChecked)
          setValue('isRepeat', !isChecked)
        }}
        checked={isChecked}>
        <RecurrenceCheckbox type="checkbox" checked={isChecked} />
        <RecurrenceLabel checked={isChecked}>{t('Repeat')}</RecurrenceLabel>
      </RecurrenceCheckboxWrapper>

      {watchIsRepeat && (
        <>
          <RecurrenceOptionsWrapper>
            <LabelInputField
              fieldLabel={t('Repeat every')}
              fieldColor="#005cd9"
              type="number"
              placeholder="6"
              initialValue="6"
              min={1}
              onChange={e => setValue('repeatWeekInterval', e.target.value)}
            />
            <RecurrenceOptionsLabel>{t('weeks')}</RecurrenceOptionsLabel>
          </RecurrenceOptionsWrapper>

          <LabelSelect
            fieldLabel={t('Recurrence type')}
            fieldColor="#005cd9"
            optionsArray={RecurrenceOptions}
            onChange={e => setValue('repeatOption', e.target.value)}
          />

          <RecurrenceRange
            setValue={setValue}
            watchRepeatOption={watchRepeatOption}
          />
        </>
      )}
    </>
  )
}
